import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useUser } from '../context/user';
const PrivateRoute = ({ exact, component: Component, ...rest }) => {
  const {
    state: {
      user, token
    }
  } = useUser();
  const location = useLocation();
  return (
    <Route
      exact={exact ? true : false}
      render={(props) =>
        (user && token) ? (
          <Component {...props} {...rest}></Component>
        ) : (
          <Redirect to={{
            pathname: '/login',
            search: `redirect=${location.pathname}`
          }}></Redirect>
        )
      }
    ></Route>
  )
};

export default PrivateRoute;
